import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Pagination } from '../../models';
import { CONFIG } from '../../../config';

@Component({
  standalone: false,
  selector: 'cci-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {

  @Input() pagination: Pagination;
  @Input() configDropdownCounter?: any;
  @Input() totalRecords: number;
  @Input() noPadding = false;
  @Output() onPageChanged = new EventEmitter();
  @Output() onRecordsPerPageChanged = new EventEmitter();
  public selectConfig = Object.assign({}, CONFIG.select.basic, { labelField: 'range', valueField: 'range', searchField: ['range'] });

  public emitPageChange() {
    this.onPageChanged.emit();
  }

  public emitRecordsPerPageChange() {
    this.onRecordsPerPageChanged.emit();
  }

}
